import React, { useState } from "react";
import { Lock } from "lucide-react";
import { Btn } from "../plan/shared";
import { setOwnerCode, studioApi, errMsg } from "../../lib/studioApi";

export const StudioGate = ({ onUnlock }) => {
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    setOwnerCode(code.trim());
    try {
      await studioApi.verify();
      onUnlock();
    } catch (ex) {
      setOwnerCode("");
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="studio-gate" className="max-w-sm mx-auto mt-24 px-6 flex flex-col gap-5">
      <div className="h-12 w-12 rounded-full bg-[#BEFF38]/10 grid place-items-center">
        <Lock className="w-5 h-5 text-[#BEFF38]" />
      </div>
      <div>
        <p className="text-[10px] font-mono uppercase tracking-[0.22em] text-[#BEFF38]">Founder only</p>
        <h1 className="text-white font-black uppercase text-3xl mt-1" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>
          Content Studio
        </h1>
        <p className="text-zinc-400 text-sm mt-2">Enter your owner code to plan and publish Instagram posts.</p>
      </div>
      <input
        data-testid="studio-gate-input"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        placeholder="FFF-XXXXXXXXXXXX"
        className="bg-[#0b0c10] border border-zinc-800 focus:border-[#BEFF38] rounded-lg px-3 py-3 text-white font-mono outline-none"
      />
      {err && <p data-testid="studio-gate-error" className="text-red-400 text-sm">{err}</p>}
      <Btn type="submit" disabled={busy || !code.trim()} data-testid="studio-gate-submit">
        {busy ? "Checking…" : "Unlock studio"}
      </Btn>
    </form>
  );
};
